import application from 'application';

window.addEventListener('error', function(event) {
  if (event.target && event.target !== window) {
    const el = event.target;
    const src = el.src || el.href || null;

    application.constructor.logError('RESOURCE_LOAD_ERROR', {
      name: 'ResourceLoadError',
      message: 'Failed to load resource',
      tagName: el.tagName,
      src,
    });
  }
}, true);

window.addEventListener('unhandledrejection', function(event) {
  event.preventDefault();

  let errorObject;
  const reason = event.reason || event.error;

  if (reason instanceof Error) {
    errorObject = reason;
  } else if (reason && typeof reason === 'object') {
    errorObject = { name: 'PromiseRejection', message: reason.message || JSON.stringify(reason) };
  } else {
    errorObject = { name: 'PromiseRejection', message: String(reason || 'Promise rejected without reason') };
  }

  application.constructor.logError('UNHANDLED_REJECTION', errorObject);
});